// extracted by mini-css-extract-plugin
export const socialButtonLink = "SocialButton__socialButtonLink__Y5VGV";
export const facebook = "SocialButton__facebook__x40Dq";
export const twitter = "SocialButton__twitter__urhYU";
export const linkedin = "SocialButton__linkedin__fLGRW";
export const socialButton = "SocialButton__socialButton__DxlTH";